// Canvas2D port of the upstream TRUNK effect by Kjetil Midtgarden Golid.
import CanvasBase from "./_canvasBase.js";
import { noise3D } from "./noise.js";
import { color2Hex } from "./helpers.js";
export default class Trunk extends CanvasBase {
  onInit() {
    this.noise = noise3D(this.options.seed);
    this.offset = this.random() * 100;
  }
  onMouseMove(x, y) {
    this.mx = (x - 0.5) * 40;
    this.my = (y - 0.5) * 40;
  }
  onUpdate() {
    this.clear();
    const c = this.context,
      o = this.options;
    c.save();
    c.translate(
      this.width / 2 + (this.mx || 0),
      this.height / 2 + (this.my || 0),
    );
    c.strokeStyle = color2Hex(o.color);
    c.lineWidth = 1;
    const scale = Math.min(this.width, this.height) / 600;
    for (let i = 0; i < o.rings; i++) {
      c.beginPath();
      const dim = 0.12 * i + 0.2;
      for (let a = 0; a <= 240; a++) {
        const angle = (a / 240) * Math.PI * 2;
        const n = this.noise(
          this.offset + Math.cos(angle) * dim,
          Math.sin(angle) * dim - this.t * 0.002,
          this.t * 0.00005,
        );
        const r =
          (50 + 4 * i + i * o.spacing + o.chaos * 20 * n * o.intensity) * scale;
        const x = Math.cos(angle) * r,
          y = Math.sin(angle) * r;
        if (a === 0) c.moveTo(x, y);
        else c.lineTo(x, y);
      }
      c.closePath();
      c.stroke();
    }
    c.restore();
  }
}
Trunk.prototype.defaultOptions = {
  color: 0x98465f,
  backgroundColor: 0x222426,
  spacing: 0,
  chaos: 1,
  rings: 45,
};
